import AttorneyData from './AttorneyData';

export default AttorneyData;
